import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { sortDDLByLabel, useNavigateToLogout } from "../../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { CategorySetupFormFields } from "./Panels/CategorySetupFormFields";
import { DDLDataTable } from "../../DDLDataTable";
import { EnhancedButtonPrimeReact } from "../../EnhancedButtonPrimeReact";
import { IAppState } from "../../../store/reducers";
import { IGetListRequest } from "../../../models";
import { IMenuHeads } from "../../../models";
import { MenuHeadSetupValidationSchema } from "./validator";
import { MenuHeadsInfoSetupFieldsPanel } from "./Panels/MenuHeadsInfoSetupFieldsPanel";
import { MenuHeadsService } from "../../../services/RoleManagementServices/MenuHeadsService"
import { MenuHeadsSetupToolbar } from "./MenuHeadsSetupToolbar";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../store/actions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";




export interface IMenuHeadsSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "menu-heads-single-data-record";
const MENUHEADS_LIST_DATA_QUERY_KEY = "menu-heads-list";

const useGetData = (
	clientId: string,
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, clientId, id, navigateToLogout],
		queryFn: () => {
			return MenuHeadsService.getById(clientId, id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useMenuHeads = (
	clientId: string,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [MENUHEADS_LIST_DATA_QUERY_KEY, params],
		queryFn: (data) => {

			return MenuHeadsService.getMenuHeads(
				clientId,
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});
const useGetParentLabelsDDL = () =>
	useQuery({
		queryKey: ["parent-Labels-DDL"],
		queryFn: (data) => {
			return MenuHeadsService.getParentLabelsDDL();
		},
		refetchOnWindowFocus: false,
	});

const useGetCategoryDDL = () =>
	useQuery({
		queryKey: ['menu-category-ddl'],
		queryFn: (data) => {
			return MenuHeadsService.getMenuCategoryDDL();
		},
		refetchOnWindowFocus: false,
	});
export const MenuHeadsSetup: React.FC<IMenuHeadsSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [menuHeadsId, setMenuHeadsId] = useState<number | string>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [openDialogue, setOpenDialogue] = useState(false)
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending, data } = useMenuHeads(
		clientId,
		queryParams,
		navigateToLogout
	);

	const menuHeadsList: any | null = data;

	const { isPending: isPendingParentLabelsDDL, data: parentLabelsDDL } =
		useGetParentLabelsDDL();

	const { isPending: isPendingErrorMessageDDLItems, data: categoryDDL } =
		useGetCategoryDDL();

	const [updatedCategoryDDL, setUpdatedCategoryDDL] = useState(categoryDDL)
	useEffect(() => {
		if (updatedCategoryDDL && categoryDDL) {
			if (categoryDDL.length !== updatedCategoryDDL.length) {
				queryClient.invalidateQueries({ queryKey: ['menu-category-ddl'] })
			}
		}
	}, [updatedCategoryDDL])

	const { isPending: isSubmitting, mutate: submitMenuHeadsFormFields } =
		useMutation({
			mutationFn: MenuHeadsService.create,
			onSuccess: (res: IMenuHeads | IServerError | IResponse | any) => {

				if (res.status === 200) {
					// if (instanceOfIMenuHeadsResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/role-management/menu-heads/${res.data.id}`;
					navigate(path);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [MENUHEADS_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: ["parent-Labels-DDL"],
						}),
					]);
				} else if (res.status === 201) {
					// if (instanceOfIMenuHeadsResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/role-management/menu-heads/${res.data.id}`;
					navigate(path);
					setEditRecordId(res.data.id);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [MENUHEADS_LIST_DATA_QUERY_KEY],
						}),
						queryClient.invalidateQueries({
							queryKey: ["parent-Labels-DDL"],
						}),
					]);
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		clientId,
		editRecordId,
		navigateToLogout
	);

	const upadtedMenuHeadsListItems = useMemo(() => {
		return (
			menuHeadsList &&
			menuHeadsList.items &&
			menuHeadsList?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/role-management/menu-heads/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{item.name}
					</Link>
				),
			}))
		);
	}, [menuHeadsList]);


	const DEFAULT_VALUES = {
		name: undefined,
		menuParentId: undefined,
		menuOrder: undefined,
		menuParentName: undefined,
	};

	const formMethods = useForm<any>({
		resolver: yupResolver(MenuHeadSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const onSubmit = (values: any) => {

		const selectedCategory = categoryDDL && categoryDDL.find((x: any) => x.value === values.category)

		// const selectedMenuParent = values.menuParentId && parentLabelsDDL && parentLabelsDDL.find((x: any) => x.value === values.menuParentId)
		const selectedMenuParent = parentLabelsDDL
			.map((x: any) =>
				x.options?.find((y: any) => y.value === values.menuParentId) ||
				(x.value === values.menuParentId ? x : null)
			)
			.find(Boolean);
		let payload = {
			clientId: clientId,
			id: id && id,
			navigateToLogout: navigateToLogout,
			name: values.name,
			menuParentId: values.menuParentId && values.menuParentId,
			menuOrder: values.menuOrder,
			menuParentName: selectedMenuParent && selectedMenuParent.label,
			category: values.category && selectedCategory ? selectedCategory.label : undefined
		};
		submitMenuHeadsFormFields(payload);
	};

	useEffect(() => {
		if (id && selectedDataRecord) {

			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (categoryDDL && fieldName === 'category' && fieldValue) {
					const selectedCategory = categoryDDL && categoryDDL.find((x: any) => x.label === fieldValue)
					formMethods.setValue(fieldName, selectedCategory.value ?? undefined);
				}
			});
		}
	}, [id, selectedDataRecord, categoryDDL]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteMenuHeadsById } = useMutation({
		mutationFn: MenuHeadsService.delMenuHeads,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the MenuHeads fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/role-management/menu-heads`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [MENUHEADS_LIST_DATA_QUERY_KEY],
			});
			return queryClient.invalidateQueries({
				queryKey: ["parent-Labels-DDL"],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteMenuHeadsField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				menuHeadsId: menuHeadsId,
				navigateToLogout: navigateToLogout,
			};
			deleteMenuHeadsById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setMenuHeadsId(selectedDataRecord.id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setMenuHeadsId(params.id);
	}, []);

	const { isPending: isArchive, mutate: archiveMenuHeadsById } = useMutation({
		mutationFn: MenuHeadsService.archiveMenuHeads,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the MenuHeads fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/role-management/menu-heads`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [MENUHEADS_LIST_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const archiveMenuHeadsField = () => {
		if (singleArchive) {
			setSingleArchive(false);
			let ArchivePayload = {
				menuHeadsId: menuHeadsId,
				navigateToLogout: navigateToLogout,
			};
			archiveMenuHeadsById(ArchivePayload);
			setArchiveDialogOpen(false);
		}
	};

	const onArchiveClicked = () => {
		setArchiveDialogOpen(true);
		setSingleArchive(true);
		if (selectedDataRecord) {
			setMenuHeadsId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		let path = `/role-management/menu-heads`;
		navigate(path);
	};

	const expandedLabels = ["Role Management"];
	const expandedMenuHeadsSetupItem = "Menu Heads"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Menu Heads" &&
				item.label === expandedMenuHeadsSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedMenuHeadsSetupItem && "/role-management/menu-heads",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		// dispatch(
		// 	setSelectedActivityLogActions({
		// 		entityId1: "",
		// 		entityId2: "",
		// 		entityId3: "",
		// 		screenName: ACCOUNTANT_SETUP_SCREEN_SLUG,
		// 		menuHeadsName: "",
		// 		activityType:
		// 			"activity_type=create&activity_type=updated&activity_type=delete",
		// 		activityLogVisibility: true,
		// 	})
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onRowEditClicked = useCallback((params: IMenuHeads | any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/role-management/menu-heads${params.value}`;
		navigate(path);
	}, []);

	const onCloseDialogueHandler = () => {
		setOpenDialogue(false)
	}
	const [isLoadingDelete, setIsLoadingDelete] =
		useState<any>(false);
	const onDeleteMenuCategoryClicked = async (id: any) => {
		(async () => {
			try {
				setIsLoadingDelete(true)
				const response: any =
					await MenuHeadsService.delMenuCategory(id);
				if (response === "Menu Category has been deleted successfully") {
					setSnackbarData({
						open: true,
						severity: "success",
						message: "Success"
					});
					queryClient.invalidateQueries({ queryKey: ['menu-category-ddl'] });
					setOpenDialogue(false)
				}
			} catch { setIsLoadingDelete(false) } finally { setIsLoadingDelete(false) }
		})();
	}

	return (
		<Grid
		// sx={{
		// 	pb: "5rem",
		// 	"& .MuiAppBar-root": {
		// 		zIndex: 2,
		// 		top: subMenuVisibility ? "154px" : "112px",
		// 	},
		// }}
		>
			<BackdropCircularProgress
				open={isSubmitting || isPendingById || isDeleting || isArchive || isPendingParentLabelsDDL || isPendingErrorMessageDDLItems}
				testId="menu head Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteMenuHeadsField}
				cancelActionHandler={onCloseHandler}
				testId="menu-heads-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 3.5, lg: 3.5, xl: 3.5 }}>
							<SingleColumnLayout
								children={
									<StandardPanel
										title="Menu Heads"
										testId={`menu-heads`}
										// leftSpacing={1}
										// rightSpacing={1}
										showTitle={false}
										variant="outlined"
										topPadding={2}
									>
										<MenuHeadsInfoSetupFieldsPanel parentLabelsDDL={parentLabelsDDL && sortDDLByLabel(parentLabelsDDL)} formMethods={formMethods}
											categoryDDL={categoryDDL && categoryDDL}
											onAddCategoryClickedHandler={() => setOpenDialogue(true)} />
									</StandardPanel>
								}
								toolbar={
									<MenuHeadsSetupToolbar
										onResetClicked={onResetClicked}
										onDeleteClicked={onDeleteClicked}
										isSubmitting={false}
										id={id}
									/>
								}
								showFullDiaplay={true}
								toolbarPosition="bottom"
								testId="form-layout"
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 4.5, lg: 4.5, xl: 4.5 }}></Grid>
						<Grid
							size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
							sx={{ marginTop: "16px" }}
						>
							<DDLDataTable
								rows={
									menuHeadsList && upadtedMenuHeadsListItems
										? upadtedMenuHeadsListItems
										: []
								}
								columns={[
									{ field: "label", headerName: "Label" },
									{ field: "menuParentName", headerName: "Parent" },
								]}
								showHeaderColumns={true}
								showArchiveIcon={false}
								onRowEditClicked={onRowEditClicked}
								onRowDeleteClicked={onRowDeleteClicked}
								onRowArchiveClicked={onArchiveClicked}
								isLoading={isPending}
								totalRecords={
									menuHeadsList && menuHeadsList.total
										? menuHeadsList.total
										: 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"60vh"}
								selectedId={selectedDataRecord && id && selectedDataRecord.id}
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
					</Grid>
				</form>
			</FormProvider>

			{/* Archive Dialogue */}
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseArchiveHandler}
				open={openArchiveDialog}
				dialogContent={null}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseArchiveHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Archive"
							severity="secondary"
							raised
							onClickHandler={() => archiveMenuHeadsField}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>

			{/* ADd Category */}
			<EnhancedDialog
				dialogTitle="Category"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseDialogueHandler}
				open={openDialogue}
				dialogContent={
					<CategorySetupFormFields
						categoryDDL={categoryDDL && sortDDLByLabel(categoryDDL)}
						updatedCategoryDDL={(value: any) => setUpdatedCategoryDDL(value)}
						onCloseCategoryHandler={() => setOpenDialogue(false)}
						onDeleteMenuCategoryClicked={onDeleteMenuCategoryClicked}
						isLoadingDelete={isLoadingDelete}
					/>
				}
				showdividers={false}
				dialogAction={
					<></>
				}
			/>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"menuHeads-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
